import { useYandexKit } from '#shared/components/YandexKitProvider';

export const useConstructorCanAddSections = (pageAlias?: string | null) => {
    const yandexKit = useYandexKit();

    return yandexKit.getPageSettings(pageAlias ?? undefined)?.canAddSections !== false;
};
